import globalTheme from 'Assets/js/components/globalTheme';

const removeElements = (nodeList) => {
  (nodeList || []).forEach((element) => {
    element.remove();
  });
};

const hideElements = (nodeList) => {
  (nodeList || []).forEach((element) => {
    element.style.display = 'none';
  });
};

const HERO_SECTION_SELECTOR = [
  '.hero-homepage',
  '.hero-half-homepage',
  '.hero-innerpage',
  '.hero-no-image',
].join(', ');

export default function maintenanceMode() {
  // Check if enabled
  if (globalTheme.maintenanceMode()) {
    // Show overlay
    document.querySelectorAll('.maintenance-mode').forEach((element) => {
      element.classList.add('maintenance-mode--visible');
    });

    // Remove all elements except hero
    removeElements(
      Array.from(document.querySelectorAll('main.site-content section')).filter(
        (section) => !section.matches(HERO_SECTION_SELECTOR)
      )
    );
    removeElements(
      document.querySelectorAll('section.hero-homepage .btn--hero')
    );
    hideElements(
      document.querySelectorAll(
        'section.hero-homepage .hero-homepage__gallery--controls'
      )
    );

    // Remove menu elements
    removeElements(
      document.querySelectorAll('.nav__bar-desktop .menu-dropdown')
    );
    removeElements(
      document.querySelectorAll(
        '.menu-overlay .overlay-menu-items-single--child'
      )
    );

    // Hide user area elements
    hideElements(document.querySelectorAll('.global-search-bar-user'));
    hideElements(document.querySelectorAll('.global-search-bar-wishlist'));
    hideElements(document.querySelectorAll('.global-search-bar-basket'));
    hideElements(
      document.querySelectorAll('.nav__top-mobile-inner-item--user')
    );
  }
}
